// extracted by mini-css-extract-plugin
export default {"wrapper":"burger-module--wrapper--xFYj0","primary":"burger-module--primary--etlAS","secondary":"burger-module--secondary--neKSi","toggled":"burger-module--toggled--NV5k7"};